import { PureComponent } from "react";
import classnames from "classnames";
import isMobile from "is-mobile";
import Segments from "/components/segments";
import colors from "/styles/colors";
import { StyledBaseLayoutSegmentComponent } from "./base-layout-segment-component.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withPreviewBaseSegment } from "contexts/preview-base-segment-context";

class BaseLayoutSegmentComponent extends PureComponent {
  getSegmentComponent() {
    const { segment } = this.props;
    return Segments[segment.type];
  }

  getSegmentBackgroundColor() {
    return this.props.segment.props.backgroundColor;
  }

  getSegmentTextColor() {
    return this.props.segment.props.textColor;
  }

  getSegmentStyleOverride() {
    return this.getSegmentComponent().baseSegmentStyleOverride || {};
  }

  getSegmentStyle() {
    const { segment } = this.props;
    let { mobilePaddingTop, mobilePaddingBottom, paddingTop, paddingBottom } = segment.props;
    if (isMobile()) {
      paddingTop = mobilePaddingTop || paddingTop;
      paddingBottom = mobilePaddingBottom || paddingBottom;
    }
    const backgroundColor = colors[this.getSegmentBackgroundColor()];
    const color = colors[this.getSegmentTextColor()];
    const segmentStyleOverride = this.getSegmentStyleOverride();

    return {
      backgroundColor,
      color,
      paddingTop,
      paddingBottom,
      ...segmentStyleOverride
    };
  }

  shouldHideSegment() {
    const { segment } = this.props;
    let { showSegment } = segment.props;
    const isMobileMode = isMobile();
    const isMobileOnly = showSegment === "mobile";
    const isDesktopOnly = showSegment === "desktop";
    const shouldHideSegment = (isMobileOnly && !isMobileMode) || (isDesktopOnly && isMobileMode);
    return shouldHideSegment;
  }

  render() {
    const { segment, isUserLoggedIn, extraProps } = this.props;
    const { isFullWidth } = segment.props;

    const SegmentComponent = this.getSegmentComponent();
    if (!SegmentComponent) return null;
    const SegmentComponentWithGenericConfig = withGenericConfig(SegmentComponent);

    const style = this.getSegmentStyle();
    if (this.shouldHideSegment()) {
      // not showing this segment for current mode
      return <div className="empty-segment" />;
    }

    return (
      <StyledBaseLayoutSegmentComponent className="base-layout-segment-component" style={style}>
        <div className={classnames("segment-content-container", { "full-width": isFullWidth })}>
          <SegmentComponentWithGenericConfig {...extraProps} {...segment.props} isUserLoggedIn={isUserLoggedIn} />
        </div>
      </StyledBaseLayoutSegmentComponent>
    );
  }
}

BaseLayoutSegmentComponent.defaultProps = {
  extraProps: {}
};

const BaseLayoutSegmentWrapperComponent = (props) => {
  const { isPreview } = props;
  const Component = isPreview ? withPreviewBaseSegment(BaseLayoutSegmentComponent) : BaseLayoutSegmentComponent;

  return <Component {...props} />;
};

export default BaseLayoutSegmentWrapperComponent;
